import { api } from "../../app/api";

export const adminsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAdmins: build.query({
      query: (params = {}) => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== "") {
            searchParams.append(key, value);
          }
        });
        return {
          url: `/admins?${searchParams.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (response) => ({
        ...response,
        data: response.data.map((admin) => ({
          ...admin,
          id: admin._id, // ensure id is present
        })),
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map((admin) => ({
                type: "Admin",
                id: admin.id || admin._id,
              })),
              { type: "Admin", id: "LIST" },
            ]
          : [{ type: "Admin", id: "LIST" }],
    }),
    getAdminById: build.query({
      query: (id) => ({
        url: `/admins/${id}`,
        method: "GET",
      }),
      transformResponse: (admin) => ({
        ...admin,
        id: admin._id,
      }),
      providesTags: (result, error, id) => [{ type: "Admin", id }],
    }),
    createAdmin: build.mutation({
      query: (body) => ({
        url: "/admins",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Admin", id: "LIST" }],
    }),
    updateAdmin: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/admins/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Admin", id },
        { type: "Admin", id: "LIST" },
      ],
    }),
    deleteAdmin: build.mutation({
      query: (id) => ({
        url: `/admins/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Admin", id },
        { type: "Admin", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetAdminsQuery,
  useGetAdminByIdQuery,
  useCreateAdminMutation,
  useUpdateAdminMutation,
  useDeleteAdminMutation,
} = adminsApi;
